import { OrderStatus } from './enums/order-status.enum';

export class OrderDetailEntity {
  constructor(
    public name: string,
    public price: number,
    public quota: string,
    public validity: string,
    public billingCycle: string,
    public subTotal: number,
    public transactionFee: number,
    public emailSended: boolean,
    public paymentCode: string,
    public timeRemaining: string
  ){}
}

export class OrderEntity extends OrderDetailEntity {
  constructor(
    public transactionId: string,
    public paymentMethod: string,
    public bankName: string,
    public redirectUrl: string,
    public total: number,
    public status: OrderStatus,
    name: string,
    price: number,
    quota: string,
    validity: string,
    billingCycle: string,
    subTotal: number,
    transactionFee: number,
    emailSended: boolean,
    paymentCode: string,
    timeRemaining: string
  ) {
    super(
      name,
      price,
      quota,
      validity,
      billingCycle,
      subTotal,
      transactionFee,
      emailSended,
      paymentCode,
      timeRemaining
    );
  }

  get isPaid(): boolean {
    return this.status === OrderStatus.paid;
  }

  get isUnpaid(): boolean {
    return this.status === OrderStatus.unpaid;
  }

  get isFailed(): boolean {
    return this.status === OrderStatus.failed;
  }

  get isExpired(): boolean {
    return this.status === OrderStatus.expired;
  }

  get isInprogress(): boolean {
    return this.status === OrderStatus.inprogress;
  }
}
